// Standard can sizes in OZ
const CAN_SIZES={'#10':105,'#5':56,'#3':33,'#2.5':29,'#2':20,'#300':15,'#1':11};

// Parse pack_size string into structured pack data
// Handles: "4/5LB", "12/14OZ", "6/.5GAL", "50LB", "6/#10", "25/16OZ", "12/3 CT"
// Standard can sizes (#10, #5, etc.) resolve to OZ equivalents
// Standalone count ("50CT") → ppc=50, spp null
export function parsePackSize(packSize, packQty){
  if(!packSize&&(!packQty||packQty<=1))return null;
  const raw=(packSize||'').trim().replace(/^Pack:\s*/i,'');
  let ppc=packQty||1;
  let spp=null;
  let pu=null; // pack unit: LB, OZ, CT, GAL, # etc.
  // Try "count/size" format: "4/5LB", "6 / #10", "12/14OZ"
  const slashMatch=raw.match(/^(\d+)\s*\/\s*(.+)$/);
  if(slashMatch){
    ppc=parseInt(slashMatch[1])||1;
    const sizeStr=slashMatch[2].trim();
    // Standard can sizes: #10→105oz, #5→56oz, etc.
    const canOz=CAN_SIZES[sizeStr]||CAN_SIZES[sizeStr.toUpperCase()];
    if(canOz){spp=canOz;pu='OZ';}
    else{
      // Extract numeric portion: "5LB"→5, "14OZ"→14, ".5GAL"→0.5, "3 CT"→3
      const numMatch=sizeStr.match(/^(\d*\.?\d+)/);
      if(numMatch){
        spp=parseFloat(numMatch[1]);
        const unitMatch=sizeStr.match(/[a-z#]+$/i);
        if(unitMatch)pu=unitMatch[0].toUpperCase();
      }
    }
  }else{
    // Single count: "50CT"→ppc=50; "3 CT"→ppc=3
    const countMatch=raw.match(/^(\d+)\s*CT\b/i);
    if(countMatch){
      ppc=parseInt(countMatch[1]);
      pu='CT';
    }else{
      // Single weight/volume: "50LB"→ppc=1,spp=50
      const numMatch=raw.match(/^(\d+\.?\d*)\s*(LB|OZ|Z|GAL|QT|PT|ML|G|KG)/i);
      if(numMatch){ppc=1;spp=parseFloat(numMatch[1]);pu=numMatch[2].toUpperCase();}
    }
  }
  // Normalize unit abbreviations to converter-compatible values
  const UNIT_NORMALIZE={
    'Z':'OZ','EA':'EACH','GR':'G','QT':'QUART','PT':'PINT',
    'CT':'EACH','ROLLS':'EACH','ROLL':'EACH',
  };
  if(pu&&UNIT_NORMALIZE[pu])pu=UNIT_NORMALIZE[pu];
  // Discard container/packaging units and ambiguous units that aren't real UOM
  // pu becomes null → auto-create falls back to EACH (column is NOT NULL)
  const INVALID_UNITS=new Set(['CS','AVG','PK','PKG','BX','BOX','BG','JUG','BTL','CAN','JAR','TUB','CASE']);
  if(pu&&INVALID_UNITS.has(pu))pu=null;
  if(ppc<=1&&!spp)return null;
  return{ppc,spp,pk:raw,pu,cq:spp?Math.round(ppc*spp*100)/100:null};
}

// Guess pack type from unit string
export function guessPackType(unit){
  if(!unit)return'CS';
  const u=unit.toUpperCase();
  if(u==='BAG'||u==='BG')return'BAG';
  if(u==='BX'||u==='BOX')return'BOX';
  if(u==='BTL')return'BOTTLE';
  if(u==='JUG')return'JUG';
  if(u==='PKG'||u==='PK')return'PACK';
  return'CS';
}
